import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentication';
import { UserRole } from '../../types/enums';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
  constructor(private authService: AuthenticationService) {}

  private getCurrentUserRole(): UserRole | null {
    return this.authService.getLoggedUserFromStorage()?.role ?? null;
  }

  canManageDepartments(): boolean {
    return this.hasRole([UserRole.Admin, UserRole.User, UserRole.Manager]);
  }

  canManageResidents(): boolean {
    return this.hasRole([UserRole.Admin, UserRole.User, UserRole.Manager]);
  }

  canMakeOrders(): boolean {
    return this.hasRole([
      UserRole.Admin,
      UserRole.Manager,
      UserRole.UserOrdererWithoutWB,
    ]);
  }

  canManageShopUsers(): boolean {
    return this.hasRole([UserRole.Admin]);
  }

  canEditCustomerInfo(): boolean {
    return this.hasRole([UserRole.Admin, UserRole.Manager]);
  }

  canAddProductsToCart(): boolean {
    return this.hasRole([
      UserRole.Admin,
      UserRole.Manager,
      UserRole.User,
      UserRole.UserCollectorWithoutWB,
      UserRole.Tester,
      UserRole.UserOrdererWithoutWB,
    ]);
  }

  hasRole(allowedRoles: UserRole[]): boolean {
    const currentRole = this.getCurrentUserRole();
    return currentRole ? allowedRoles.includes(currentRole) : false;
  }
}
